export default {
  salePurchase: {
    message: {
      submitAgain: '继续提交',
      gitUpSubmitAgain: '您已放弃继续提交',
      onlyEnglishNumbersCharacters: '只能输入英文，数字和字符！',
      creditList: '信用额度列表',
      monthlySalesAgreementCreation: '月度销售协议创建',
      monthlySalesAgreementEdit: '月度销售协议修改',
      salesOverviewEnquiries: '销售总览查询',
      serviceOverviewEnquiries: '服务合同总览查询',
      premiumOverviewEnquiries: '升贴水合同总览查询',
      procurementOverviewEnquiry: '采购总览查询',
      del: '删除',
      forbidden: '禁用',
      singleSalesContractCreation: '单次销售合同创建',
      serviceContractAdd: '服务合同创建',
      premiumContractAdd: '升贴水合同创建',
      singleSalesContractEdit: '单次销售合同修改',
      serviceContractEdit: '服务合同修改',
      premiumContractEdit: '升贴水合同修改',
      salesBillLadingCreation: '销售提单创建',
      salesIntentionSheetCreation: '销售意向单创建',
      modificationSalesIntention: '销售意向单修改',
      yes: '是',
      no: '否',
      annualSalesAgreementModification: '年度销售协议修改',
      annualSalesAgreementAdd: '年度销售协议创建',
      salesReturn: '退货',
      exchangeGoods: '换货',
      salesReplacementEditor: '销售换货单编辑',
      salesReplacementAdd: '销售换货创建',
      editSalesReturns: '销售退货单编辑',
      addSalesReturns: '销售退货创建',
      examinationApproval: '审批中',
      approve: '审批通过',
      beenDisabled: '已禁用',
      approvalDismiss: '审批驳回',
      dismissReason: '驳回原因',
      theSaved: '已保存',
      openBill: '已开提单',
      noPricing: '未定价',
      havePricing: '已定价',
      gitUpSubmit: '已放弃提交',
      noRejectComments: '请填写修改意见',
      isMillion: '意向单金额不可超过人民币100万，请通过合同实现该业务',
      substantiveChange: '实质性变更',
      notSubstantiveChange: '非实质性变更',
      isCreditsaled: '零售业务无法赊销，请检查后提交',
      addInvoice: '开票',
      submitRelationTitle: '提交确认',
      submitRelationContent: '请同步修改已关联的提单号',
    },
    RMB: '人民币',
    addBill: '创建合同',
    addIntent: '创建意向单',
    addMonthPurchase: '创建月度采购协议',
    addSinglePurchase: '创建单次采购合同',
    addSupplierDelivery: '创建供应商发货指令',
    addMonthSales: '创建月度销售协议',
    addSingleSales: '创建单次销售合同',
    addLadingBill: '创建提单',
    addInvoice: '开票',
    copyBtn: '复制',
    noDeleteContractTips: '请选择已保存和已驳回的合同进行删除',
    noDeleteContractTipsHN: '请选择已保存的合同进行删除',
    noDeleteAgreementTips: '请选择已保存和已驳回的协议进行删除',
    noDeleteIntentionTips: '请选择已保存和已驳回的意向单进行删除',
    noDeleteAgreementTipsHN: '请选择已保存的合同进行删除',
    noBillTips: '年度销售协议不可开提单',
    noBillContractTips: '只有已生效的合同才能提单',
    noBillIntentionTips: '只有已生效的意向单才能提单',
    noBillAgreementTips: '只有已生效的协议才能提单',
    noBill2Tips: '只有已生效的合同/月度协议/意向单才能创建提单',
    addContractTips: '请选择一个意向单或协议',
    copyContractTips: '请勾选一条已生效的数据',
    sumbitContractTips: '请选择已保存的销售合同/协议进行提交',
    sumbitContractTipsHN: '请选择已保存的合同进行提交',
    noSubmitTips: '只有已保存的合同/月度协议/意向单才可提交',
    noSubmitContractTips: '只有已保存和已驳回的合同才可提交',
    noSubmitIntentionTips: '只有已保存和已驳回的意向单才可提交',
    noSubmitAgreementTips: '只有已保存、修订中、修订已驳回、已驳回的单据才可提交',
    noExportTips: '请至少选择一列导出',
    noSupplier: '请先选择合作伙伴',
    noCustomer: '请先选择客户',
    addBillTips: '请选择一条已生效的合同/月度协议/意向单进行提单',
    noCopyContractTips: '只能复制已生效的合同',
    noCopyAgreementTips: '只能复制已生效的协议',
    noCopyIntentionTips: '只能复制已生效的意向单',
    noAddContractTips: '只有协议和意向单才能创建合同',
    notAddAgreementTips: '只有已生效的协议才能创建合同',
    notAddIntentionTips: '只有已生效的意向单才能创建合同',
    addSupplierDeliveryContractTips: '请勾选一条已生效合同或意向单的数据',
    priceIndication: '参考价格',
    isPriceChange: '确定变更单价吗',
    cancelPriceChange: '取消变更',
    confirm: '提示',
    operateStatusClose: '关闭合同',
    operateStatusOpen: '激活合同',
    revert: '申请撤销',
    confirmRevert: '确认撤销',
    cancelRevert: '驳回撤销',
    doConfirm: '确认',
    doCancel: '取消',
    gapRange: '请输入',
    ptcombiNo: '请输入策略号',
    closeFlag: '合同尚未执行完毕，请完全执行后关闭',
    search: {
      contractCategory: '制单类型',
      contractTotalAmountServiceLocal: '合同总金额(本币)',
      contractTotalAmountLocalPlaceholder: '请输入合同总金额本币',
      contractOperaterName: '制单人',
      externalContractNo: '外部合同号',
      intentionNo: '意向单号',
      contractNo: '合同编号',
      purchaseCreateDateHN: '签约日期',
      tradeType: '贸易类型',
      warehouse: '仓库',
      customer: '客户名称',
      customerType: '客户类别',
      purchaseCurrency: '货币',
      product: '商品描述',
      settleBatchNumber: '结算批次号',
      contractTotalAmount: '合同总金额',
      intentionTotalAmount: '意向单金额',
      contractCreateStartDate: '制单开始日期',
      contractCreateEndDate: '制单结束日期',
      businessContractUnitPrice: '合同单价',
      productQuantity: '销售数量',
      purchaseQuantity: '采购数量',
      payerName: '付款单位',
      receiptCondition: '付款条件',
      performancePeriodSale: '天数',
      contractCreateDate: '创建日期',
      purchaseCreateDate: '制单日期',
      contractStatus: '单据状态',
      lastestPayMoneyDay: '最晚付款日',
      lastestReceiveMoneyDay: '最晚收款日',
      lastestSendProductDay: '最晚发货日',
      lastestSendProductDayHN: '交货时间',
      lastestReceiveProductDay: '最晚收货日',
      supplychain: '供应链主体',
      supplychainNo: '供应链主体编码',
      supplychainName: '供应链主体名称',
      supplierNo: '供应商名称',
      partyA: '甲方(供方)',
      partyB: '乙方(需方)',
      contractBusinessDepartment: '业务部门',
      contractOperaterNo: '操作人',
      contractSalesmanNo: '业务员',
      businessType: '业务性质',
      isFixedPrice: '不定价',
      isSalesFixedPrice: '代理不定价',
      isCreditsale: '赊销',
      isPrepay: '预付',
      isNotProxy: '贸易非代理',
      creditPercent: '保证金比例',
      companyCode: '公司',
      purchaseNo: '采购号(合同/意向单)',
      supplierType: '供应商类别',
      contractCurrencyExchangeRate: '汇率',
      receiptMethod: '付款方式',
      receiptPurchaseCondition: '付款条件',
      collectMethod: '收款方式',
      collectCondition: '收款条件',
      pricingRule: '定价规则',
      credit: '信用额度查询',
      orderLadingLimit: '可放货额度查询',
      creditAmount: '预付金额', //有误（赊销）
      prepayAmount: '预付金额',
      dailyDeliveryQuantity: '日交货量',
      creditsaleAmount: '赊销金额',
      businessOrder: '业务订单',
      overShippedPercentage: '溢装比例',
      shortShippedPercentage: '短装比例',
      isStorage: '其他入库',
      isInsure: '投保',
      isHedging: '套期保值',
      hedgingType: '套值保期类型',
      contractValidStart: '合同有效期起',
      contractValidEnd: '合同有效期至',
      isNeedMonthlyContract: '另签月度采购合同',
      ladingQuantity: '已开提单数量',
      invoiceAmount: '已开票金额',
      notInvoiceAmount: '未开票金额',
      large: '大于',
      small: '小于',
      equal: '等于',
      notEqual: '不等于',
      ladingQuantityPlaceholder: '请输入已开提单数量',
      invoiceAmountPlaceholder: '请输入已开票金额',
      notInvoiceAmountPlaceholder: '请输入未开票金额',
      contractCategoryPlaceholder: '请选择制单类型',
      contractCategoryPlaceholderHN: '请选择订单类型',
      externalContractNoPlaceholder: '请输入外部合同号',
      intentionNoPlaceholder: '请输入意向单号',
      contractNoPlaceholder: '请输入合同编号',
      contractNoPlaceholderHN: '请输入订单编号',
      addContractNoPlaceholder: '自动生成',
      tradeTypePlaceholder: '请选择贸易类型',
      settleBatchNumberPlaceholder: '请输入结算批次',
      payerNamePlaceholder: '请输入付款单位',
      receiptConditionPlaceholder: '请输入付款条件',
      performancePeriodSalePlaceholder: '请输入天数',
      contractStatusPlaceholder: '请选择订单状态',
      isFixedPricePlaceholder: '请选择是否定价',
      isCreditsalePlaceholder: '请选择是否赊销',
      isPrepayPlaceholder: '请选择是否预付',
      creditPercentPlaceholder: '请输入保证金比例',
      businessTypePlaceholder: '请选择业务性质',
      companyCodePlaceholder: '请选择公司',
      departmentPlaceholder: '请选择部门',
      supplierTypePlaceholder: '请选择供应商类别',
      contractBusinessDepartmentPlaceholder: '请选择业务部门',
      contractSalesmanNoPlaceholder: '请选择业务员',
      exchangeRatePlaceholder: '请输入汇率',
      receiptMethodPlaceholder: '请选择付款方式',
      collectMethodPlaceholder: '请选择收款方式',
      collectConditionPlaceholder: '请输入收款条件',
      pricingRulePlaceholder: '请选择定价规则',
      creditAmountPlaceholder: '请输入预付金额',
      creditsaleAmountPlaceholder: '请输入赊销金额',
      contractTotalAmountPlaceholder: '请输入合同总金额',
      businessOrderPlaceholder: '请输入业务订单',
      overShippedPercentagePlaceholder: '请输入溢装比例',
      shortShippedPercentagePlaceholder: '请输入短装比例',
      hedgingTypePlaceholder: '请选择套值保期类型',
      dailyDeliveryQuantityPlaceholder: '请输入日交货量',
      contractNoHN: '订单编号',
      tradeTypeHN: '贸易类型',
      tradeTypeHNPlaceholder: '请选择贸易类型',
      contractDetailCategoryHN: '订单类型',
      businessTypeHN: '经营方式',
      businessTypeHNPlaceholder: '请选择经营方式',
      contractCreateDateHN: '签约日期',
      contractCreateDateHNStart: '签约开始日期',
      contractCreateDateHNEnd: '签约结束日期',
      creditsaleAmountHN: '赊销利率水平',
      creditsaleAmountHNPlaceholder: '请输入赊销利率水平',
      priceType: '销售单价类型',
      salePriceTypePlaceholder: '请选择销售单价类型',
      performancePeriod: '履约期',
      performancePeriodPlaceholder: '请输入履约期',
      latestPerformanceDate: '最晚履约期',
      latestPerformanceDatePlaceholder: '请输入最晚履约期',
      marginPercentage: '保证金比率',
      marginPercentagePlaceholder: '请输入保证金比率',
      marginPercentageHN: '保证金比率(%)',
      marginAmount: '保证金',
      marginAmountPlaceholder: '请输入保证金',
      interestRate: '利率水平',
      interestRatePlaceholder: '请输入利率水平',
      customerContactPerson: '客户联系人',
      customerContactPersonPlaceholder: '请输入客户联系人',
      customerContactTel: '联系方式',
      customerContactTelPlaceholder: '请输入联系方式',
      shippedQuantity: '销售发货数量',
      shippedQuantityPlaceholder: '请输入销售发货数量',
      adjustedMarginAmount: '保证金金额(调整后)',
      adjustedMarginAmountPlaceholder: '请输入保证金金额(调整后)',
      isPriceDifferenceOrder: '差价订单',
      isContractOrder: '合约订单',
      mark: '备注',
      rejectComments: '修改意见',
      rejectCommentsPlaceholder: '请输入修改意见',
      contractBusinessCompanyNo: '公司',
      contractBusinessCompanyName: '请选择公司',
      agency: '由贸易合同生成',
    },
    nosearchError: '请输入至少一条查询条件进行查询',
    noTypeSearchError: '请选择制单类型',
    searchError: '请输入正确的查询条件',
    noOrderError: '请选择一个类型创建新单',
    table: {
      intentionNo: '销售意向单号',
      salesNo: '销售号(合同/意向单)',
      salesNoService: '合同编号',
      salesNoHN: '订单编号',
      contractNo: '销售合同编号',
      contractDetailNo: '行项目号',
      productNo: '商品编码',
      productDesc: '商品描述',
      contractCreateDate: '制单日期',
      gmtCreate: '创建日期',
      contractTotalAmount: '合同总金额',
      contractTotalAmountService: '合同总价(原币)',
      invoiceAmountService: '已开票金额(原币)',
      invoiceAmount: '已开票金额',
      notInvoiceAmount: '未开票金额',
      contractTotalAmountServiceLocal: '合同总价(本币)',
      // businessContractTaxAmountService: '合同税额(原币)',
      businessContractTaxAmountServiceLocal: '合同税额(本币)',
      businessContractPureAmountService: '净值(原币)',
      businessContractPureAmountServiceLocal: '净值(本币)',
      productQuantity: '采购数量',
      contractQuantity: '合同数量',
      saleQuantity: '销售数量',
      supplierName: '供应商名称',
      businessTypeHN: '经营方式',
      performancePeriod: '履约期',
      marginPercentage: '保证金比率',
      adjustedMarginAmount: '保证金',
      contractStatusHN: '订单状态',
      saleQuantityHN: '签约数量',
      contractPrice: '合同价格',
      businessContractUnitPrice: '合同单价',
      businessContractUnitPriceHNSales: '订单单价',
      businessContractUnitPriceHN: '销售单价(￥/KG)',
      businessContractUnitPriceHNPurchase: '采购单价',
      businessContractTotalAmount: '价税合计金额',
      businessContractTotalAmountService: '合同总价(原币)',
      businessContractTotalAmountLocalService: '合同总价(本币)',
      businessContractTotalAmountHN: '销售金额',
      businessContractTotalAmountHNSales: '订单金额',
      businessContractTotalAmountHNPurchase: '采购金额',
      businessContractTaxAmount: '税额',
      businessContractTaxAmountService: '合同税额（原币/本币）',
      businessContractPureAmount: '净值',
      businessContractPureAmount2Service: '净值(原币/本币)',
      productUnitPrice: '贷款单价',
      shippingUnitExpense: '运费单价',
      storageNo: '仓库',
      flow: '直拨流向',
      deliveryPlace: '交货地点',
      isFixedPrice: '是否定价',
      price: '变动价格',
      businessChangeUnitPrice: '变动单价',
      priceConfirmDate: '价格确定时间',
      priceIdentity: '价格标识',
      unit: '单位',
      unitHN: '计量单位',
      deliverType: '交货方式',
      taxRate: '税率',
      taxRefundRate: '出口退税率',
      estimatedCommission: '预计佣金',
      shippingMethod: '运输方式',
      shippingExpense: '运输费用',
      shippingExpenseHN: '运费单价',
      ptcombiNo: '策略号',
      settleBatchNumber: '结算批次',
      valueAddedTaxRate: '增值税',
      annualTransactions: '年交易数量',
      monthTransactions: '月交易数量',
      annualDelivery: '年交货数量',
      monthDelivery: '月交货数量',
      contractStatus: '单据状态',
      taxCode: '税码',
      gapRange: '基差',
      avgUnitPrice: '平均变动单价',
      // taxRefundRate:'退税率',
      importNormalTariffRate: '进口关税',
      onlyInsertOneData: '只能新增一条数据',
      detailBusinessOrder: '业务订单',
      contractBusinessCompanyName: '公司',
      contractBusinessDepartment: '业务部门',
      customerName: '客户名称',
      payerName: '付款单位',
      contractSalesman: '业务员',
      currencyName: '货币',
      ladingQuantityToShow: '提单数量',
      actualQuantityToShow: '实发数量',
    },
    addOrder: '创建新单',
    add: {
      info: '基本信息',
      contractBusinessCompanyNoNotEmpty: '公司不能为空',
      tradeTypeNotEmpty: '贸易类型不能为空',
      businessTypeNotEmpty: '业务性质不能为空',
      supplierTypeNotEmpty: '供应商类别不能为空',
      pricingRuleNotEmpty: '定价规则不能为空',
      hedgingTypeNotEmpty: '套值保期不能为空',
      supplierNotEmpty: '供应商不能为空',
      lastestPayMoneyDayNotEmpty: '最晚付款日不能为空',
      lastestReceiveMoneyDayNotEmpty: '最晚收款日不能为空',
      lastestReceiveProductDayNotEmpty: '最晚收货日不能为空',
      lastestSendProductDayNotEmpty: '最晚发货日不能为空',
      creditAmountNotEmpty: '赊销金额不能为空',
      paymentAmountNotEmpty: '预付金额不能为空',
      supplierNoNotEmpty: '甲方不能为空',
      // customerNotEmpty: '乙方不能为空',
      purchaseCurrencyNotEmpty: '货币不能为空',
      exportCountryNotEmpty: '出口国别不能为空',
      salesCountryNotEmpty: '销售国别不能为空',
      inportCountryNotEmpty: '进口国别不能为空',
      purchaseCountryNotEmpty: '采购国别不能为空',
      contractValidStartNotEmpty: '合同有效期起不能为空',
      contractValidEndNotEmpty: '合同有效期止不能为空',
      customerNotEmpty: '客户名称不能为空',
      business: '交易明细',
      product: '产品明细',
      productHN: '明细信息',
      relation: '关联明细',
      interest: '利息计算',
      transport: '运输信息',
      exportport: '出口明细',
      importport: '进口明细',
      historicalPerformance: '历史执行情况',
      contractBusinessDepartment: '业务部门不能为空',
      contractSalesman: '业务员不能为空',
      tradeTypeHNNotEmpty: '贸易类型不能为空',
      businessHNNTypeNotEmpty: '经营方式不能为空',
      businessTypeHNNotEmpty: '经营方式不能为空',
      performancePeriodNotEmpty: '履约期不能为空',
      marginPercentageNotEmpty: '保证金比率不能为空',
      interestRateNotEmpty: '利率水平不能为空',
      creditInterestRateNotEmpty: '赊销利率水平不能为空',
      rejectCommentsNotEmpty: '修改意见不能为空',
      externalContractNoNotEmpty: '外部合同号不能为空',
      overShippedPercentageNotEmpty: '溢装比例不能为空',
      shortShippedPercentageNotEmpty: '短装比例不能为空',
      supplychainNotEmpty: '供应链主体不能为空',
    },
    productDescNotEmpty: '商品描述不能为空',
    productQuantityNotEmpty: '采购数量不能为空',
    salesQuantityNotEmpty: '销售数量不能为空',
    businessContractUnitPriceNotEmpty: '合同单价不能为空',
    businessContractTotalAmountNotEmpty: '价税合计金额不能为空',
    businessContractTaxAmountNotEmpty: '税额不能为空',
    businessContractPureAmountNotEmpty: '净值不能为空',
    storageNotEmpty: '仓库不能为空',
    shippingNotEmpty: '运输方式不能为空',
    realPriceNotEmpty: '实时参考价不能为空',
    computeNotEmpty: '计算公式不能为空',
    changePriceNotEmpty: '变动单价不能为空',
    changeQuantityNotEmpty: '定价数量不能为空',
    unitNameNotEmpty: '单位不能为空',
    deliverTypeNotEmpty: '交货方式不能为空',
    taxCode: '税码不能为空',
    taxRefundRate: '退税率不能为空',
    importNormalTariffRate: '进口关税不能为空',
    annualTransactionsNotEmpty: '年交货数量不能为空',
    annualNotEmpty: '年交易数量不能为空',
    productQuantityMax: '月交易数量不能大于年交易数量',
    productMounthYear: '月交货量不能大于年交货量',
    exportport: '请完善出口明细',
    importport: '请完善进口明细',
    companyCurrencyEmpty: '本位币不能为空',
    purchaseBusinessUnitPriceNotEmpty: '采购单价不能为空',
    proxyBusinessUnitPriceNotEmpty: '销售单价不能为空',
    price: {
      realPrice: '实时参考价格',
      priceDetail: '查询价格',
      compute: '计算公式',
      changePrice: '变动单价',
      changeQuantity: '定价数量',
      productDesc: '商品描述',
      productQuantity: '数量',
      productUnit: '单位',
      salesUnitPrice: '合同单价',
      priceIdentity: '价格标示',
      pricingRule: '定价规则',
      temporaryPrice: '变动价格',
      confirmDate: '价格确认时间',
      operatorName: '操作人',
      noSelectPrice: '请选择一条记录或者显示上述日期范围内均价',
      pricingStatusName: '状态',
      priceName: '价格名称',
      taxCode: '税码',
      taxRate: '税率',
      priceWithTax: '含税价',
      priceWithoutTax: '净价',
      changeTime: '变更时间',
      changeUserName: '变更人名称',
      priceType: '费用类别',
    },
    other: {
      isDiscount: '优惠',
      priceExplain: '价格说明',
      purchaseOriginCoin: '合同价格(原币)',
      purchaseLocalCoin: '合同价格(本币)',
      proxyOriginCoin: '变动价格(原币)',
      proxyLocalCoin: '变动价格(本币)',
      remark: '备注',
      relative: '关联合同',
    },
    interset: {
      isInterest: '是否收取利息',
      interestRule: '计算规则',
      interestRulePlaceholder: '请输入计算规则',
      startDate: '起息日期',
      overdueDate: '逾期日期',
      acceptanceDiscountMonthlyRate: '承兑贴息月利率',
      currencyType: '货币',
      overdualName: '利息档次',
      overdualDays: '逾期天数',
      overdualMonthlyRate: '月利率（‰）',
    },
    transport: {
      deliveryStorage: '发货仓库',
      startAddress: '起运地',
      originAddress: '产地',
      destinationAddress: '目的地',
      freightExpense: '运杂费',
      freightExpenseLocal: '运杂费(本币)',
      storageExpense: '仓储费',
      storageExpenseLocal: '仓储费(本币)',
      outInExpense: '出入库费',
      outInExpenseLocal: '出入库费(本币)',
      loadingUnitPrice: '装车费单价',
      loadingUnitPriceLocal: '装车费单价(本币)',
      deliveryUnitPrice: '运输费单价',
      deliveryUnitPriceLocal: '运输费单价(本币)',
      acceptanceDiscountUnitPrice: '承兑贴息单价',
      acceptanceDiscountUnitPriceLocal: '承兑贴息单价(本币)',
      lastestShipmentDate: '最迟装船日期',
      lastestDeliveryDate: '最迟交货日期',
      latestReceivDate: '最迟收货日期',
      actualShipmentDate: '实际装期',
      otherExpenseComment: '其他费用说明',
      shipmentCondition: '装运条件',
      startAddressPlaceholder: '请输入起运地',
      originAddressPlaceholder: '请输入产地',
      destinationAddressPlaceholder: '请输入目的地',
      freightExpensePlaceholder: '请输入运杂费',
      storageExpensePlaceholder: '请输入仓储费',
      // storageExpensePlaceholder: '请输入出入库费',
      loadingUnitPricePlaceholder: '请输入装车费单价',
      deliveryUnitPricePlaceholder: '请输入运输费单价',
      acceptanceDiscountUnitPricePlaceholder: '请输入承兑贴息单价',
    },
    export: {
      exportCountry: '出口国别',
      salesCountry: '销售国别',
      tradeTerms: '国际贸易条款',
      exportCountryPlaceholder: '请选择出口国别',
      salesCountryPlaceholder: '请选择销售国别',
      tradeTermsPlaceholder: '请输入国际贸易条款',
    },
    import: {
      inportCountry: '进口国别',
      purchaseCountry: '采购国别',
      estimateMoney: '预计佣金金额',
      inportCountryPlaceholder: '请选择进口国别',
      purchaseCountryPlaceholder: '请选择采购国别',
      estimateMoneyPlaceholder: '请输入佣金金额',
    },
    settleInfo: {
      settleNo: '结算批次号',
      settleDesc: '结算批次描述',
      settleTypeName: '结算类型名称',
      shippingName: '装运名称',
      deliveryQuantity: '发货数量',
      settleNoPlaceholder: '请输入结算批次号',
      settleStatusName: '状态',
    },
    history: {
      relationPurTitle: '关联采购合同历史执行情况',
      relationSalesTitle: '关联销售合同历史执行情况',
      logisticsInfo: '物流信息',
      contractRow: '合同行',
      contractNum: '合同数量',
      instructionNumber: '供应商发货指令数量',
      noDelievery: '尚未发货数',
      logisticsQuanitity: '物流入库数',
      noLogisticsQuanitity: '尚未物流入库数',
      businessQuanitity: '业务入库数',
      noBusinessQuanitity: '尚未业务入库',
      supplierDeliveryIns: '供应商发货指令',
      count: '数量',
      logisticsNo: '物流入库单号',
      businessNo: '业务入库单号',
      businessInboundBatchNo: '业务入库批次号',
      paymentInformation: '付款信息',
      collectInfomation: '收款信息',
      contractTotalAmount: '合同总金额',
      goodsAmount: '商品金额',
      amountPaid: '已付款金额',
      collectAmount: '已收款金额',
      invoicedAmount: '已开票金额',
      paymentAmount: '付款金额',
      invoiceNumber: '发票编号',
      paymentDate: '付款日期',
      noPaymentDate: '未付款金额',
      invoiceInformation: '发票信息',
      overladingQuantity: '已开提单数量',
      noOverLadingQuantity: '未开提单数量',
      ladingNo: '销售提单数量',
      ladingQuantity: '提单数量',
      actualSendQuantity: '物流已出库数量',
      noActualSendQuantity: '物流未出库数量',
      invoiceNo: '提单号',
      // invoiceInformation:'物流出库单',
      // invoiceInformation:'出库单数量',
      outboundNo: '物流出库单号',
      storageSendQuantity: '出库数量',
      goldenTaxDate: '开票日期',
      invoiceQuantity: '开票数量',
      invoiceCode: '发票编码',
      invoiceAmount: '开票金额',
      originReceiveMoneyAmount: '收款金额',
      collectDate: '收款日期',
    },
    supplierConfirmation: '代供应商确认',
  },
};
